export const load = () => ({
	title: 'Street Noise Reduction in the City',
	showTitle: true,
});
